import axios from 'axios';
import {
  ApiEnvelope,
  MintTokenResponse,
  PayPixResponse,
  PaymentStatusResponse,
  SearchDebtsResponse,
} from './types';

const FINGERPRINT_KEY = 'ZA:publicFingerprint';

export const getPublicFingerprint = (): string => {
  try {
    let fingerprint = sessionStorage.getItem(FINGERPRINT_KEY);
    if (!fingerprint) {
      fingerprint =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      sessionStorage.setItem(FINGERPRINT_KEY, fingerprint);
    }
    return fingerprint;
  } catch {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
};

/** Axios próprio: rotas públicas não passam pelo interceptor autenticado. */
const publicApi = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

publicApi.interceptors.request.use((config) => {
  if (!config.headers) config.headers = {};
  config.headers['X-Fingerprint'] = getPublicFingerprint();
  return config;
});

export const mintPublicDebtToken = (body: {
  plate?: string;
  notificationId?: number;
  captchaToken: string;
}) => publicApi.post<MintTokenResponse>('public/debts/token', body);

export const searchPublicDebts = (body: {
  token?: string;
  plate?: string;
  notificationId?: number;
  captchaToken: string;
}) => publicApi.post<SearchDebtsResponse>('public/debts/search', body);

export const resolveAdminDebtToken = (body: {
  token: string;
  captchaToken: string;
}) => publicApi.post<SearchDebtsResponse>('public/debts/from-admin-token', body);

export const payPublicDebtPix = (body: {
  paymentTokens: string[];
  captchaToken: string;
}) => publicApi.post<PayPixResponse>('public/debts/pay/pix', body);

export const getPublicPaymentStatus = (statusToken: string) =>
  publicApi.get<PaymentStatusResponse>(`public/payments/${statusToken}`);

export const cancelPublicDebtPix = (statusToken: string) =>
  publicApi.post<PaymentStatusResponse>(
    `public/payments/${statusToken}/cancel`,
  );

export const sendPublicPaymentReceipt = (statusToken: string, email: string) =>
  publicApi.post<ApiEnvelope<string>>(`public/payments/${statusToken}/receipt`, {
    email,
  });

export * from './types';
